import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/customer/tenant/add/customer.tenant.assign.mutation.gql"
import type {
  CustomerTenantAssignMutation,
  CustomerTenantAssignMutationVariables,
} from "@/v2-backoffice-client/customer/tenant/add/__types__/customer.tenant.assign.mutation"

type Options = MutationHookOptions<
  CustomerTenantAssignMutation,
  CustomerTenantAssignMutationVariables
>

export function useCustomerTenantAssignMutation(options?: Options) {
  return useMutation<
    CustomerTenantAssignMutation,
    CustomerTenantAssignMutationVariables
  >(mutation, options)
}
